import React from 'react'
import { Routes, Route } from "react-router-dom";

import { DatoScreen } from '../componentes/view/operaciones/informacion_gps_transporte/DatoScreen'; 
import ConsultaLiquidaciones from '../componentes/view/operaciones/liquidacion/liquidacionOpe'; 
import EditarLiquidaciones from '../componentes/view/operaciones/liquidacion/liquidacionPen';
import ConsultaDocumentosLiquidados from '../componentes/view/operaciones/liquidacion/liquidados';
import SolicitudesEntregas from '../componentes/view/operaciones/entregas/SolicitudesEntregas';
export const OperacionRoutes = () => {

  return (
    <Routes>            
      <Route path="/dato_gps_transporte" element={ <DatoScreen /> } /> 
      <Route path="/liquidacion" element={ <ConsultaLiquidaciones /> } /> 
      <Route path="/edit-liquidacion" element={ <EditarLiquidaciones /> } />
      <Route path="/liquidados" element={ <ConsultaDocumentosLiquidados /> } />  
      <Route path="/solicitudentregas" element={<SolicitudesEntregas/>} />
    </Routes>
  )
}
